import { render } from "./NameAvatar.vue?vue&type=template&id=1c2be444"
import script from "./NameAvatar.vue?vue&type=script&lang=js"
export * from "./NameAvatar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__